export enum PlanStatusActive {
  ACTIVE = "active",
  CANCELLED = "cancelled",
}

export enum PlanName {
  FREE_TRIAL = "Free Trial",
  PLAN_MONTHLY = "All-In-One PlanMonthly",
}

export enum ValidationSuscriptionButton {
  PLAN_FREE_TRIAL = "PLAN_FREE_TRIAL",
  RECORDING_USAGES = "RECORDING_USAGES",
}

export enum StatusFile {
  ERROR = "Error",
  READY = "Ready",
  PROCESSING = "Processing",
  GENERATING = "Generating",
}

export enum DefaultRecordingTemplates {
  SOAP = "SOAP Template",
  SPECIALIST = "Specialist Template",
  VOICE_TO_TEXT = "Voice to Text Dictation",
}

export enum MicDeviceType {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

export enum AuthStatus {
  LOADING = "loading",
  AUTHENTICATED = "authenticated",
  UNAUTHENTICATED = "unauthenticated",
}

export enum StripeCustomerSessionType {
  CUSTOMER_SESSION = "customer_session",
  BILLING_SESSION = "billing_session",
}
